<!-- start header -->
<div class="container">

    <div class="row mt-4 mb-3 align-items-center">
        <div class="col-6 text-start align-self-center">
            &nbsp;&nbsp;&nbsp;
            <span class="ai-tool-header">{{toolName}}</span>
            <!-- <img src="https://sdesk-rebranding.s3.eu-central-1.amazonaws.com/NEXA_logo.png" alt="Girl in a jacket"> -->
            <!-- Left content if any -->
        </div>
      
        <!-- Make this col a flex container for the icons -->
        <div class="col-6 d-flex align-items-center justify-content-end">

            <i
            [matTooltip]="'Bookmark'"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'sdesk-tooltip'"
            (click)="toggleNexaSave()" *ngIf="nexaSave && activateSave" class="fas fa-bookmark fa-lg divLink"></i>
            <i 
            [matTooltip]="'Bookmark'"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'sdesk-tooltip'"
            (click)="toggleNexaSave()" *ngIf="!nexaSave && activateSave" class="far fa-bookmark fa-lg divLink"></i>
  
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <i
            [matTooltip]="'Refresh'"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'sdesk-tooltip'"
            (click)="refreshCheckNEXAAI()" class="fas fa-redo fa-1x divLink me-2"></i>
          
          <i 
            *ngIf="pinned && activatePin"
            (click)="togglePIN()"
            [matTooltip]="'Pinned'"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'sdesk-tooltip'"
            class="fas fa-thumbtack fa-1x divLink me-2">
          </i>
      
          <i 
            *ngIf="!pinned && activatePin"
            (click)="togglePIN()"
            [matTooltip]="'Unpinned'"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'sdesk-tooltip'"
            class="fas fa-thumbtack fa-rotate-180 fa-1x divLink mb-2">
          </i>

          &nbsp;&nbsp;&nbsp;         
        </div>
      </div>
</div>
<!-- end header -->
 <app-loading-spinner *ngIf="loading" ></app-loading-spinner>

 <div *ngIf="!loading && ticketError == null">
    <div *ngFor="let panel of panels" class="accordion-container">

        <!-- start accordion header -->
        <div class="accordion" [class.active]="panel.active" (click)="togglePanel(panel)">
    
            <h4 class="suggested-next-steps-h4">
                {{ panel.title }}
            </h4>
          <!-- Toggle icon: shows '+' when closed, '-' when open -->
          <span class="toggle-icon">{{ panel.active ? '−' : '+' }}</span>
        </div>
        <!-- end accordion header -->
    
        <!-- start accordion content panel -->
        <div class="panel" [style.display]="panel.active ? 'block' : 'none'">
    
            <!-- start panel 1 -->
            <ng-container *ngIf="panel.id === 1">
    
                <div class="tabs-container">
                    <ul class="tabs-header">
                        <li *ngFor="let tab of tabs"
                            [class.active]="tab === activeTab"
                            (click)="selectTab(tab)">
                        {{ tab.title }}
                        </li>
                    </ul>
    
                    <div *ngIf="activeTab.id === 1" class="tabs-content">
                        <ul>
                            <li class="suggested-next-steps">                
                                <div class="suggested-next-steps">
                                    <span class="step-header">Requester: </span> <span class="step-details">{{ activeTab.requester }}</span>
                                </div>
                            </li>
                                
                            <li class="suggested-next-steps">                
                                <div class="suggested-next-steps">
                                    <span class="step-header">Issue: </span> <span class="step-details">{{ activeTab.issue }}</span>
                                </div>
                            </li>
                                    
                            <li class="suggested-next-steps">                
                                <div class="suggested-next-steps">
                                    <span class="step-header">Description: </span> <span class="step-details">{{ activeTab.description }}</span>
                                </div>
                            </li>
                
                            <li class="suggested-next-steps">                
                                <div class="suggested-next-steps">
                                    <span class="step-header">Priority: </span> <span class="step-details">{{ activeTab.priority }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
    
            </ng-container>
            <!-- end panel 1 -->
        
            <!-- start panel 2 -->
            <ng-container *ngIf="panel.id === 2">
    
                <ol *ngIf="panel.content && panel.content.length > 0">
                    <li class="suggested-next-steps" *ngFor="let stepItem of panel.content">                
                    <!-- Step number and title on one line -->
                    <div class="suggested-next-steps">
                        <span class="step-header">{{ stepItem.title }}</span>
                    </div>
                    <!-- Step details on the next line(s) -->
                    <div class="suggested-next-steps">
                        <span class="step-details">{{ stepItem.details }}</span>
                    </div>
                    </li>
                </ol>        
            </ng-container>
            <!-- end panel 2 -->
    
            <!-- start panel 3 -->
            <ng-container *ngIf="panel.id === 3">
            <p>{{ panel.content }}</p>
            </ng-container>
            <!-- end panel 3 -->
    
        </div>
        <!-- end accordion content panel -->
    
    </div>
</div>
<!-- end panels -->




